<template >
  <div id="adminShop" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>爬虫执行情况</el-breadcrumb-item>
      <el-breadcrumb-item>监控店铺</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-row class="executionPage">
        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            监控店铺今日监控计划数分布
          </div>
          <div class="fontDiv2" v-loading="echLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-col :span="24">
              <div id="chartLineBox" style="width: 100%;height: 400px;"> </div>
            </el-col>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            监控店铺今日计划监控链接数
          </div>
          <div class="fontDiv2" v-loading="echLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-col :span="24">
              <div id="planChartLineBox" style="width: 100%;height: 400px;"></div>
            </el-col>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            监控店铺今日实际监控链接数
          </div>
          <div class="fontDiv2" v-loading="echLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-col :span="24">
              <div id="dayChartLineBox" style="width: 100%;height: 400px;"></div>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    data(){
      return{
        echLoading: false,
        planSeries:[],
        hourArr: [
          '00:00',
          '01:00',
          '02:00',
          '03:00',
          '04:00',
          '05:00',
          '06:00',
          '07:00',
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
          '22:00',
          '23:00',
        ],
      }
    },
    mounted() {
      this.getOverviewByShopMonitor()
    },
    methods:{
      getOverviewByShopMonitor() {
        this.echLoading = true
        fetch({
          url: "hcm/hcmShopMonitor/getOverviewByShopMonitor",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            let planTB = []
            let planTM = []
            let planJD = []
            let planSN = []
            let plan1688 = []
            let planDD = []
            let planDayTB = []
            let planDayTM = []
            let planDayJD = []
            let planDaySN = []
            let planDay1688 = []
            let planDayDD = []
            this.planSeries = []
            this.planSeries = res.data.planSeries[0].data
            if (res.data.planMonitorSeries) {
              for (let a in res.data.planMonitorSeries) {
                if (res.data.planMonitorSeries[a].name == '天猫') {
                  planTM.push(res.data.planMonitorSeries[a].data)
                } else if (res.data.planMonitorSeries[a].name == '淘宝') {
                  planTB.push(res.data.planMonitorSeries[a].data)
                } else if (res.data.planMonitorSeries[a].name == '京东') {
                  planJD.push(res.data.planMonitorSeries[a].data)
                } else if (res.data.planMonitorSeries[a].name == '苏宁') {
                  planSN.push(res.data.planMonitorSeries[a].data)
                } else if (res.data.planMonitorSeries[a].name == '1688') {
                  plan1688.push(res.data.planMonitorSeries[a].data)
                } else if (res.data.planMonitorSeries[a].name == '当当') {
                  planDD.push(res.data.planMonitorSeries[a].data)
                }
              }
            }
            if (res.data.monitorDataSeries) {
              for (let a in res.data.monitorDataSeries) {
                if (res.data.monitorDataSeries[a].name == '天猫') {
                  planDayTM.push(res.data.monitorDataSeries[a].data)
                } else if (res.data.monitorDataSeries[a].name == '淘宝') {
                  planDayTB.push(res.data.monitorDataSeries[a].data)
                } else if (res.data.monitorDataSeries[a].name == '京东') {
                  planDayJD.push(res.data.monitorDataSeries[a].data)
                } else if (res.data.monitorDataSeries[a].name == '苏宁') {
                  planDaySN.push(res.data.monitorDataSeries[a].data)
                } else if (res.data.monitorDataSeries[a].name == '1688') {
                  planDay1688.push(res.data.monitorDataSeries[a].data)
                } else if (res.data.monitorDataSeries[a].name == '当当') {
                  planDayDD.push(res.data.monitorDataSeries[a].data)
                }
              }
            }
            this.planSeriesEcharts(this.planSeries)
            this.planMonitorSeriesEcharts(planTB,planTM,planJD,planSN,plan1688,planDD)
            this.monitorDataSeriesEcharts(planDayTB,planDayTM,planDayJD,planDaySN,planDay1688,planDayDD)
            this.echLoading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      monitorDataSeriesEcharts(planDayTB,planDayTM,planDayJD,planDaySN,planDay1688,planDayDD) {
        this.chartLine3 = echarts.init(document.getElementById('dayChartLineBox'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['淘宝','天猫','京东','苏宁','1688','当当']
          },
          color: ['#1890ff','#2fc25b','#facc14','#223273','#8543e0','#13c2c2'],
          xAxis: {
            type: 'category',
            data: this.hourArr,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '淘宝',
              data:  planDayTB[0],
              type: 'bar',
              stack: '同',
            },{
              name: '天猫',
              data:  planDayTM[0],
              type: 'bar',
              stack: '同',
            },{
              name: '京东',
              data:  planDayJD[0],
              type: 'bar',
              stack: '同',
            },{
              name: '苏宁',
              data:  planDaySN[0],
              type: 'bar',
              stack: '同',
            },{
              name: '1688',
              data:  planDay1688[0],
              type: 'bar',
              stack: '同',
            },{
              name: '当当',
              data:  planDayDD[0],
              type: 'bar',
              stack: '同',
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine3.setOption(option);
      },
      planMonitorSeriesEcharts(planTB,planTM,planJD,planSN,plan1688,planDD) {
        this.chartLine2 = echarts.init(document.getElementById('planChartLineBox'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['淘宝','天猫','京东','苏宁','1688','当当']
          },
          color: ['#1890ff','#2fc25b','#facc14','#223273','#8543e0','#13c2c2'],
          xAxis: {
            type: 'category',
            data: this.hourArr,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '淘宝',
              data:  planTB[0],
              type: 'bar',
              stack: '相同',
            },{
              name: '天猫',
              data:  planTM[0],
              type: 'bar',
              stack: '相同',
            },{
              name: '京东',
              data:  planJD[0],
              type: 'bar',
              stack: '相同',
            },{
              name: '苏宁',
              data:  planSN[0],
              type: 'bar',
              stack: '相同',
            },{
              name: '1688',
              data:  plan1688[0],
              type: 'bar',
              stack: '相同',
            },{
              name: '当当',
              data:  planDD[0],
              type: 'bar',
              stack: '相同',
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine2.setOption(option);
      },
      // echarts表格展示
      planSeriesEcharts(planSeries) {
        this.chartLine = echarts.init(document.getElementById('chartLineBox'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['计划个数']
          },
          color: ['#1890ff'],
          xAxis: {
            type: 'category',
            data: this.hourArr,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '计划个数',
              data:  planSeries,
              type: 'bar',
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
    }
  }
</script>

<style lang="scss">
  #adminShop{
    .executionPage {
      margin: 20px;
      .iconDiv {
        width: 5px;
        background-color: #333333;
        margin-right: 10px;
        height: 21px;
        margin-top: 4px;
      }
      .fontDiv2 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        margin-right: 20px;
        height: 360px;
        margin-bottom: 20px;
      }
    }
  }
</style>
